import { render, staticRenderFns } from "./PlaceAction.vue?vue&type=template&id=f3c11dec&"
import script from "./PlaceAction.vue?vue&type=script&lang=js&"
export * from "./PlaceAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports